/** THIS FILE IS AUTOMATICALLY GENERATED FROM : https://webapi-dev.egged.co.il/swagger/v1/swagger.json **/

import axios from "../axios"
import * as Egged from "./EggedInterfaces"

export const postCareerHeadquartersApply = (
  formData: FormData,
  onUploadProgress?: (progressEvent: any) => void,
  locale?: string,
) =>
  axios.post<Egged.BooleanResponseWrapper>(
    `/api/career/headquartersApply`,
    formData,
    {
      onUploadProgress,
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Accept-Language": locale,
      },
    },
  )

export const postCareerDriverOrCollegeApply = (
  data: Egged.CallboxPublicRequest,
  locale?: string,
) =>
  axios.post<Egged.BooleanResponseWrapper>(
    `/api/career/driverOrCollegeApply`,
    data,
    { headers: { "X-Accept-Language": locale } },
  )

export const postCareerAllHeadquartersJobs = (
  data: Egged.GetHeadquartersJobsRequest,
  locale?: string,
) =>
  axios.post<Egged.HeadquarterJobPublicResponsePaginatedListResultResponseWrapper>(
    `/api/career/allHeadquartersJobs`,
    data,
    { headers: { "X-Accept-Language": locale } },
  )

export const getCareerHeadquarterJob = (
  jobId: number /* int32 */,
  locale?: string,
) =>
  axios.get<Egged.HeadquarterJobExtendedPublicResponseResponseWrapper>(
    `/api/career/headquarterJob`,
    { params: { jobId }, headers: { "X-Accept-Language": locale } },
  )

export const getContactsUsTypes = (locale?: string) =>
  axios.get<Egged.Int32StringValueTupleListResponseWrapper>(
    `/api/contactsUs/types`,
    { headers: { "X-Accept-Language": locale } },
  )

export const postContactsUsCreate = (
  data: Egged.CreateContactUsPublicRequest,
  locale?: string,
) =>
  axios.post<Egged.InsertComplaintPublicResponseResponseWrapper>(
    `/api/contactsUs/create`,
    data,
    { headers: { "X-Accept-Language": locale } },
  )

export const getFinesDetails = (
  fineId: number /* int64 */,
  fineNumerator: number /* int64 */,
  recaptcha: string,
  locale?: string,
) =>
  axios.get<Egged.FineDetailsPublicResponseResponseWrapper>(
    `/api/fines/details`,
    {
      params: { fineId, fineNumerator, recaptcha },
      headers: { "X-Accept-Language": locale },
    },
  )

export const postFinesPayment = (
  data: Egged.FinePaymentRequest,
  locale?: string,
) =>
  axios.post<Egged.PaymentSetupPublicResponseResponseWrapper>(
    `/api/fines/payment`,
    data,
    { headers: { "X-Accept-Language": locale } },
  )

export const getFinesPaymentDone = (
  Succeed: boolean,
  TxId: string,
  UniqueID: string,
  ErrorCode: string,
  ErrorText: string,
  Lang: string,
  Mid: string,
  CardExp: string,
  PersonalId: string,
  CardToken: string,
  CardMask: string,
  NumberOfPayments: number /* int32 */,
  FirstPayment: string,
  PeriodicalPayment: string,
  CgUid: string,
  ResponseMac: string,
  UserData2: string,
  UserData3: string,
  UserData4: string,
  UserData5: string,
  locale?: string,
) =>
  axios.get<any>(`/api/fines/paymentDone`, {
    params: {
      Succeed,
      TxId,
      UniqueID,
      ErrorCode,
      ErrorText,
      Lang,
      Mid,
      CardExp,
      PersonalId,
      CardToken,
      CardMask,
      NumberOfPayments,
      FirstPayment,
      PeriodicalPayment,
      CgUid,
      ResponseMac,
      UserData2,
      UserData3,
      UserData4,
      UserData5,
    },
    headers: { "X-Accept-Language": locale },
  })

export const getSettingsAll = (locale?: string) =>
  axios.get<Egged.GeneralSettingResponseListResponseWrapper>(
    `/api/settings/all`,
    { headers: { "X-Accept-Language": locale } },
  )

export const getLostFoundCaseStatus = (
  caseNumber: number /* double */,
  phoneNumber: number /* double */,
  locale?: string,
) =>
  axios.get<Egged.LostFoundCaseStatusPublicResponseResponseWrapper>(
    `/api/lostFound/caseStatus`,
    {
      params: { caseNumber, phoneNumber },
      headers: { "X-Accept-Language": locale },
    },
  )

export const getLostFoundColors = (locale?: string) =>
  axios.get<Egged.LostFoundColorPublicResponseListResponseWrapper>(
    `/api/lostFound/colors`,
    { headers: { "X-Accept-Language": locale } },
  )

export const getLostFoundContent = (locale?: string) =>
  axios.get<Egged.LostFoundContentPublicResponseListResponseWrapper>(
    `/api/lostFound/content`,
    { headers: { "X-Accept-Language": locale } },
  )

export const getLostFoundTrip = (
  shilut: number /* double */,
  lostDate: string /* date-time */,
  locale?: string,
) =>
  axios.get<Egged.LostFoundTripDetailsPublicResponseListResponseWrapper>(
    `/api/lostFound/trip`,
    { params: { shilut, lostDate }, headers: { "X-Accept-Language": locale } },
  )

export const postLostFoundCreateCase = (
  data: Egged.LostFoundCreateCasePublicRequest,
  locale?: string,
) =>
  axios.post<Egged.LostFoundCasePublicResponseResponseWrapper>(
    `/api/lostFound/createCase`,
    data,
    { headers: { "X-Accept-Language": locale } },
  )

export const getTestLocalDateTime = (locale?: string) =>
  axios.get<Egged.DateTimeResponseWrapper>(`/api/test/localDateTime`, {
    headers: { "X-Accept-Language": locale },
  })

export const postTrafficUpdateAll = (
  data: Egged.TrafficUpdatesRequest,
  locale?: string,
) =>
  axios.post<Egged.TrafficUpdatesDtoResponseWrapper>(
    `/api/trafficUpdate/all`,
    data,
    { headers: { "X-Accept-Language": locale } },
  )

export const getTrafficUpdateGetById = (
  messageId: number /* int64 */,
  locale?: string,
) =>
  axios.get<Egged.ExtendedTrafficUpdateDtoResponseWrapper>(
    `/api/trafficUpdate/getById`,
    { params: { messageId }, headers: { "X-Accept-Language": locale } },
  )
